import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import getLocal from 'eco-design-reliance/getLocal';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const MoreIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 6L15 12L9 18" stroke="#18191B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default function TheComp() {
    const { t } = useLang('aboutus.I');
    const { locale } = getLocal();

    const item = [
        {
            title: t('title1'),
            link: `https://www.ecoflow.com/${locale}/powerforall`,
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767694312285-vnq8pk-compressed-image%2001.jpg',
        },
        {
            title: t('title2'),
            link: locale === 'au' ? 'https://www.ecoflow.com/au/news' : 'https://www.ecoflow.com/us/news',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767694329072-rgkuif-compressed-image%2002.jpg',
        },
        {
            title: t('title3'),
            link: 'https://www.linkedin.com/company/ecoflowtech/jobs',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767694340615-ef9hae-compressed-image%2003.jpg',
        },
    ];

    return (
        <section id="about-us-I" className={`about-us-I ${css.section} GtmModuleData-section`} data-section-id="About-Us-I">
            <div className="list-container">
                <div className="list">
                    {item.map((i, index) => (
                        <div className="item" key={index}>
                            <div className="img-box">
                                <EcoImg pc={i.pc} className="comp-bg" />
                            </div>
                            <div className="text-box">
                                <div className="title">{i.title}</div>

                                <EcoLink href={i.link} className="item-btn GtmModuleData-btn-common" target="_blank" data-btn-id={i.link}>
                                    <span className="link-text">{t('more')}</span>
                                    <div className="icon">
                                        <MoreIcon />
                                    </div>
                                </EcoLink>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
